import {ValidatorFn} from '@angular/forms';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildAsyncValidators, buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import {FieldAffix} from '../../affix/field-affix';
import {AsyncCustomValidatorFn, CustomValidatorFn} from '../../validation/custom-validatror';
import {FieldLabel} from '../../label/fileld-label';
import {FieldTypeEnum} from '../../dynamic-field/field-type.enum';
import {ButtonToggleFieldConfig} from "./button-toggle.config";


export const buttonToggleFieldControlBuilder: ControlBuilder = (fieldConfig: ButtonToggleFieldConfig, formBuilder) => {
    const {disabled, value} = fieldConfig;

    const validators = buttonToggleFieldValidators(fieldConfig);
    const asyncValidators = buildAsyncValidators(fieldConfig);
    const multiOptionObject = initialValueChecker(fieldConfig.buttons, fieldConfig.value);
    return formBuilder.group(multiOptionObject, {asyncValidators, validators});

};


export const buttonToggleFieldValidators: (fieldConfig: { hidden?: boolean; prefix?: FieldAffix; validators?: Array<CustomValidatorFn> | CustomValidatorFn; label?: FieldLabel; type: FieldTypeEnum; suffix?: FieldAffix; required?: boolean; asyncValidators?: Array<AsyncCustomValidatorFn> | AsyncCustomValidatorFn; readonly?: boolean; name: string; disabled?: boolean; id?: string; class?: string; value?: Promise<any> | any }) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        return buildDefaultValidators(config);
    };

function initialValueChecker(source, value) {
    const obj = {};
    if(!source){
        return obj;
    }
    for (const key of Object.keys(source)) {
        if (value) {
            obj[key] = (key in value);
        } else {
            obj[key] = false;
        }

    }
    return obj;
}
